import { curryN } from "../libs/ramda";
export default curryN(3, function (label, name, value) {
    return { label: label, name: name, value: value };
});
